import React from 'react';
import { Form } from 'react-bootstrap';
import '../sharedFormControl.css'

const CustomRadioButton = (props) => {

    const onChange = (event) => {

        if (props.onChange)
            props.onChange(props.objectKey, event.target.checked, event.target.value);

    }

    return (
        <React.Fragment>
            <fieldset className='default-fieldset default-radio-btn'>
                <span className='input-label-wrap'>
                    <span className='input-field-wrap'>
                        <input
                            type='radio'
                            className='form-radio-btn'
                            required={props.required}
                            disabled={props.disabled ? props.disabled : false}
                            name={props.objectKey}
                            placeholder={props.placeholder}
                            value={props.value}
                            checked={props.checked}
                            onChange={event => onChange(event)}
                            style={props.style ? props.style : {}}
                        />
                        <span className={props.disabled && !props.checked ?
                            'default-disable-radio-box-img' :
                            props.disabled && props.checked ?
                                'default-radio-disable-radio-box-img default-radio-btn-img'
                                : 'default-radio-btn-img'}></span>
                        {/* This class is used to add background images and styles for Radio Button */}
                    </span>
                    {
                        !props.labelIcon ? '' : <span className='label-icon-image'>{props.labelIcon}</span>
                    }
                    <legend className={`default-fieldset-label radioCheckboxLabel ${props.disabled ? 'disabled-text' : null}`}>{props.label ? props.label : ''}</legend>
                </span>
            </fieldset>
            <Form.Control.Feedback type="invalid">
                {props.errorMessage ? props.errorMessage : `${props.name} is required.`}
            </Form.Control.Feedback>
        </React.Fragment>
    )

}

export default CustomRadioButton;